export const groupsMixin = {
    data() {
        return {
            group1: ['tulipan', 'napocska', 'margareta'],
            group2: ['suni', 'halacska', 'pillango', 'katica'],
            tulipan: {
                title: 'groups.tulip.title',
                employers: [
                    {firstname: 'Veronika', lastname: 'Bereczki', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Ildikó', lastname: 'Király', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Katalin', lastname: 'Elek', rank: 'groups.carer'},
                ],
                card_back: ['groups.age_group_5_6', 'groups.type_same'],
                introduction_sections: [
                    'groups.tulip.section_1',
                    'groups.tulip.section_2',
                    'groups.tulip.section_3',
                    'groups.tulip.section_4',
                ],
                name: 'tulipan',
                gallerySrc: [
                    "tulipan/1.jpg",
                    "tulipan/2.jpg",
                    "tulipan/3.jpg",
                    "tulipan/4.jpg",
                    "tulipan/5.jpg",
                    "tulipan/6.jpg",
                    "tulipan/7.jpg",
                    "tulipan/8.jpg",
                    "tulipan/9.jpg",
                    "tulipan/10.jpg",
                    "tulipan/11.jpg",
                    "tulipan/12.jpg",
                    "tulipan/13.jpg",
                    "tulipan/14.jpg",
                    "tulipan/15.jpg",
                    "tulipan/16.jpg",
                ]
            },
            napocska: {
                title: 'groups.sun.title',
                employers: [
                    {firstname: 'Edina', lastname: 'Gavallérné Kiss', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Panna', lastname: 'Huszti', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Erika', lastname: 'Mesterné Orsó', rank: 'groups.carer'},
                ],
                card_back: ['groups.age_group_6_7', 'groups.type_same'],
                introduction_sections: [
                    'groups.sun.section_1',
                    'groups.sun.section_2',
                    'groups.sun.section_3',
                    'groups.sun.section_4',
                    'groups.sun.section_5',
                    'groups.sun.section_6',
                    'groups.sun.section_7',
                ],
                name: 'napocska',
                gallerySrc: [
                    "napocska/1.jpg",
                    "napocska/2.jpg",
                    "napocska/3.jpg",
                    "napocska/4.jpg",
                    "napocska/5.jpg",
                    "napocska/6.jpg",
                    "napocska/7.jpg",
                    "napocska/8.jpg",
                    "napocska/9.jpg",
                    "napocska/10.jpg",
                    "napocska/11.jpg",
                    "napocska/12.jpg",
                    "napocska/13.jpg",
                ]
            },
            margareta: {
                title: 'groups.daisy.title',
                employers: [
                    {firstname: 'Mónika', lastname: 'Burai Pál Józsefné ', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Sarolta', lastname: 'Papp', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Izabell', lastname: 'Gajdics', rank: 'groups.teaching_assistant'},
                    {firstname: 'Katalin', lastname: 'Vargáné Bakos', rank: 'groups.carer'},
                ],
                card_back: ['groups.age_group_3_5', 'groups.type_mixed'],
                introduction_sections: [
                    'groups.daisy.section_1',
                    'groups.daisy.section_2',
                    'groups.daisy.section_3',
                    'groups.daisy.section_4',
                    'groups.daisy.section_5',
                ],
                name: 'margareta',
                gallerySrc: [
                    "margareta/1.jpg",
                    "margareta/2.jpg",
                    "margareta/3.jpg",
                    "margareta/4.jpg",
                    "margareta/5.jpg",
                    "margareta/6.jpg",
                    "margareta/7.jpg",
                    "margareta/8.jpg",
                    "margareta/9.jpg",
                    "margareta/10.jpg",
                ]
            },
            suni: {
                title: 'groups.hedgehog.title',
                employers: [
                    {firstname: 'Tünde', lastname: 'Hegedüsné Laza', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Enikő', lastname: 'Biczó-Vas', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Magdolna', lastname: 'Kuna', rank: 'groups.carer'},
                ],
                card_back: ['groups.age_group_4_5', 'groups.type_same'],
                introduction_sections: [
                    'groups.hedgehog.section_1',
                    'groups.hedgehog.section_2',
                    'groups.hedgehog.section_3'
                ],
                name: 'suni',
                gallerySrc: [
                    "suni/1.jpg",
                    "suni/2.jpg",
                    "suni/3.jpg",
                    "suni/4.jpg",
                    "suni/5.jpg"
                ]
            },
            halacska: {
                title: 'groups.fish.title',
                employers: [
                    {firstname: 'Márta', lastname: 'Czére-Nagy', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Boglárka', lastname: 'Medve', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Erzsike', lastname: 'Czinege Zsoltné ', rank: 'groups.carer'},
                ],
                card_back: ['groups.age_group_5_6', 'groups.type_same'],
                introduction_sections: [
                    'groups.fish.section_1',
                    'groups.fish.section_2',
                    'groups.fish.section_3',
                    'groups.fish.section_4',
                    'groups.fish.section_5',
                ],
                name: 'halacska',
                gallerySrc: [
                    "halacska/1.jpg",
                    "halacska/2.jpg",
                    "halacska/3.jpg",
                ]
            },
            pillango: {
                title: 'groups.butterfly.title',
                card_back: ['groups.age_group_6_7', 'groups.type_same'],
                employers: [
                    {firstname: 'Valéria ', lastname: 'Molnár', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Mónika', lastname: 'Szőkéné Prétli', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Ágnes', lastname: 'Milák', rank: 'groups.carer'}
                ],
                introduction_sections: [
                    'groups.butterfly.section_1',
                    'groups.butterfly.section_2',
                    'groups.butterfly.section_3',
                    'groups.butterfly.section_4',
                    'groups.butterfly.section_5',
                    'groups.butterfly.section_6',
                ],
                name: 'pillango',
                gallerySrc: [
                    "pillango/1.jpg",
                    "pillango/2.jpg",
                    "pillango/3.jpg",
                    "pillango/4.jpg",
                    "pillango/5.jpg",
                    "pillango/6.jpg",
                    "pillango/7.jpg",
                    "pillango/8.jpg",
                    "pillango/9.jpg",
                    "pillango/10.jpg",
                    "pillango/11.jpg",
                    "pillango/12.jpg",
                    "pillango/13.jpg",
                    "pillango/14.jpg",
                ]
            },
            katica: {
                title: 'groups.ladybird.title',
                card_back: ['groups.age_group_3_4', 'groups.type_same'],
                employers: [
                    {firstname: 'Ildikó', lastname: 'Török', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Krisztina', lastname: 'Bakonyi', rank: 'groups.kindergarten_teacher'},
                    {firstname: 'Katika', lastname: 'Radócz Sándorné', rank: 'groups.teaching_assistant'},
                    {firstname: 'Anikó', lastname: 'Kaprinyák', rank: 'groups.carer'}
                ],
                introduction_sections: [
                    'groups.ladybird.section_1',
                    'groups.ladybird.section_2',
                    'groups.ladybird.section_3',
                    'groups.ladybird.section_4',
                ],
                name: 'katica',
                gallerySrc: [
                    "katica/1.jpg",
                    "katica/2.jpg",
                    "katica/3.jpg",
                    "katica/4.jpg",
                    "katica/5.jpg",
                    "katica/6.jpg",
                    "katica/7.jpg",
                    "katica/8.jpg",
                    "katica/9.jpg",
                    "katica/10.jpg",
                    "katica/11.jpg"
                ]
            },
        }
    },
    methods: {
        getObject(name) {
            return this[name]
        }
    }
}
